import './index.scss';
import Language from '../../i18n/Language';
import { Link } from "@shopify/polaris";
const t = Language;

const FooterTrustHelp = () => {

    return <div className="FooterTrustHelp">
        <img src="/logoAndTextCw.svg" width={116} height={32} alt="" />
        <div>
            <p>{t("Over 30000+ brands use SEOAnt to grow their business.")}</p>
            <p>{t("Learn more about")}&nbsp;<Link target='_blank' url="https://www.seoant.com/">SEOAnt</Link>&nbsp;&nbsp;{t("by")}&nbsp;<Link target='_blank' url="https://www.channelwill.com/">Channelwill</Link></p>
        </div>
        <img src="/footer-trust.png" width={105} height={30} alt="" />
    </div>
}

export default FooterTrustHelp;
